export default {"src":"/_next/static/media/range.314f6674.svg","height":281,"width":379,"blurWidth":0,"blurHeight":0};